import { buildClientRoutePath } from 'navigation/clientRouteManifest';

/**
 * Centralized route constants for the frontend-main application.
 * Use these constants instead of hardcoding route strings throughout the app.
 */

export const ROUTES = {
  // Layout prefix
  EMPRESA_LAYOUT: '/empresa',

  // Main routes
  HOME: buildClientRoutePath('home'),
  EMPRESAS: buildClientRoutePath('companies'),
  NUEVA_EMPRESA: buildClientRoutePath('create_company'),
  IMPORT_EMPRESA: buildClientRoutePath('import_company'),
  MIS_IMPORTS: buildClientRoutePath('imports'),
  IMPORT_DETALLE: (importId) =>
    buildClientRoutePath('import_detail', { importId }),
  SOPORTE: buildClientRoutePath('support'),
  CUENTA: buildClientRoutePath('settings'),
  REFERIDOS: buildClientRoutePath('referrals'),

  // Company-scoped routes (new)
  COMPANY_DASHBOARD: (companyId) =>
    buildClientRoutePath('company_dashboard', { companyId }),
  COMPANY_PAYMENT: (companyId) =>
    buildClientRoutePath('company_payment', { companyId }),
  COMPANY_NOTIFICATIONS: (companyId) =>
    buildClientRoutePath('company_notifications', { companyId }),
  COMPANY_DOCUMENTS: (companyId) =>
    buildClientRoutePath('company_documents', { companyId }),
  COMPANY_BANKING: (companyId) =>
    buildClientRoutePath('company_banking', { companyId }),
  COMPANY_LILI_ONBOARDING: (companyId) =>
    buildClientRoutePath('company_lili', { companyId }),
  COMPANY_TAXES: (companyId) =>
    buildClientRoutePath('company_taxes', { companyId }),
  COMPANY_PERKS: (companyId) =>
    buildClientRoutePath('company_perks', { companyId }),
  COMPANY_INVOICES: (companyId) =>
    buildClientRoutePath('company_invoices', { companyId }),
  COMPANY_MONTHLY_CLOSE: (companyId) =>
    buildClientRoutePath('company_monthly_close', { companyId }),
  COMPANY_COMMAND: (companyId) =>
    buildClientRoutePath('company_command', { companyId }),
  COMPANY_COMMAND_APPROVALS: (companyId) =>
    buildClientRoutePath('command_approvals', { companyId }),
  COMPANY_COMMAND_INTEGRATIONS: (companyId) =>
    buildClientRoutePath('command_integrations', { companyId }),
  COMPANY_COMMAND_PAYMENTS: (companyId) =>
    buildClientRoutePath('command_payments', { companyId }),
  COMPANY_COMMAND_STUDIO: (companyId) =>
    buildClientRoutePath('command_studio', { companyId }),
  COMPANY_COMMAND_BANKING: (companyId) =>
    buildClientRoutePath('command_banking', { companyId }),
  COMPANY_COMMAND_LILI: (companyId) =>
    buildClientRoutePath('command_lili', { companyId }),
  COMPANY_MEMBER_CHANGES: (companyId) =>
    buildClientRoutePath('company_member_changes', { companyId }),
  COMPANY_EIN_SERVICE: (companyId) =>
    buildClientRoutePath('company_ein', { companyId }),
  COMPANY_SERVICE_REQUESTS: (companyId) =>
    buildClientRoutePath('company_service_requests', { companyId }),

  // Service routes (placeholders)
  BANCO: '/empresa/banco',
  IMPUESTOS: '/empresa/impuestos',

  // Auth routes
  SIGN_IN: buildClientRoutePath('sign_in'),
  SIGN_UP: buildClientRoutePath('sign_up'),

  // Public routes
  TERMINOS: '/terminos',
  PRIVACIDAD: '/privacidad',
  BLOG: '/blog',
  BLOG_POST: (slug) => `/blog/${slug}`,

  // Dynamic routes (functions)
  PERFIL_EMPRESA: (registrationId) =>
    buildClientRoutePath('company_profile', { registrationId }),
};

export default ROUTES;
